export default [
    {
        path: '/analysis/useranalysis',
        name: 'Useranalysis',
        component: () => import('@/pages/analysis/Useranalysis.vue'),
        meta: {
            title: '用户分析',
            requireAuth: true,
            authority: 'analysis:useranalysis'
        }
    },
    {
        path: '/analysis/flowanalysis',
        name: 'Flowanalysis',
        component: () => import('@/pages/analysis/Flowanalysis.vue'),
        meta: {
            title: '流量分析',
            requireAuth: true,
            authority: 'analysis:flowanalysis'
        }
    },
    {
        path: '/analysis/incomeanalysis',
        name: 'Incomeanalysis',
        component: () => import('@/pages/analysis/Incomeanalysis.vue'),
        meta: {
            title: '交易分析',
            requireAuth: true,
            authority: 'analysis:incomeanalysis'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/module/analysis.js